export default __webpack_public_path__ + "static/media/wifi-4.a723abd7.svg";